import type { FieldBinding } from '@doer/frontend-components/creativity-editor';
import { RoutedFormData } from 'src/types/templates';

const LABEL_CANDIDATES = ['label', 'name', 'itemValue', 'value'];

const extractLabel = (item: unknown): string | undefined => {
  if (item == null) return undefined;
  if (typeof item === 'string') return item || undefined;
  if (typeof item !== 'object') return undefined;

  const record = item as Record<string, unknown>;
  for (const key of LABEL_CANDIDATES) {
    const value = record[key];
    if (typeof value === 'string' && value) return value;
  }
  return undefined;
};

const extractIndex = (pieceId: string, pattern: string): number | null => {
  const regex = new RegExp('^' + pattern.replace('{index}', '(\\d+)') + '$');
  const match = pieceId.match(regex);
  return match ? Number(match[1]) : null;
};

export const resolveLayerLabel = (
  pieceId: string | undefined,
  formData: RoutedFormData,
  fieldBindings: FieldBinding[]
): string | undefined => {
  if (!pieceId) return undefined;

  for (const binding of fieldBindings) {
    if (binding.kind === 'simple' && binding.pieceId === pieceId) {
      return extractLabel(formData[binding.fieldKey]);
    }

    if (binding.kind === 'array') {
      const index = extractIndex(pieceId, binding.pieceIdPattern);
      if (index == null) continue;

      const arr = formData[binding.fieldKey];
      if (!Array.isArray(arr)) continue;

      return extractLabel(arr[index]);
    }
  }

  return undefined;
};
